<template>
  <div class="modal-container">
    <div class="total-size-modal" ref="modal">
      <h2 class="modal-title">
        Ingresar total de hectáreas a sembrar
      </h2>
      <div class="d-flex justify-content-center align-items-center gap-2">
        <numbersInput :type="'text'" :placeholder="0" :class-name="'total-size-input'" :value="size" v-on:change="changeSize" v-on:keyup.enter="submitOnEnter"/>
        <!-- <span class="h3"> 
          Has.
        </span> -->
        <span> 
          Has.
        </span>
      </div>
      <ErrorMessage v-if="error.length" :text="error" />
      <button class="confirm-btn" @click="handleSubmit">OK</button>
    </div>
  </div>
</template>
<script>
import ErrorMessage from './errorMessage.vue';
import numbersInput from './numbersInput.vue';
export default {
  name: "total-size-modal",
  props: {
    divisionIndex: Number,
  },
  components: {
    ErrorMessage,
    numbersInput
  },
  data() {
    return {
      size: null,
      error: ""
    }
  },
  methods: {
    changeSize(event){
      this.size = parseInt(event.target.value);
    },
    handleClick(e) {
      if (this.isTotalSizeModal) return;
    },
    handleSubmit() {
      // Handle submiting when isTotalSizeModal
      this.error = ""
      if (!this.size || this.size <= 0) {
        this.error = "Por favor, ingrese un valor para el tamaño total";
        return
      }
      this.$emit('submitTotalSize', this.size)
    },
    submitOnEnter(event) {
      if (event.keyCode === 13){
        if (event.target.value) {
          this.size = parseInt(event.target.value);
        } else {
          this.size = 0
        }
        this.handleSubmit();
      }
    },
  }
}
</script>
<style scoped>

.total-size-input {
  border: 2px solid var(--dark-gray);
  width: 20rem;
  height: 3rem;
  padding: 1rem;
  text-align: center;
  font-size: 2rem;
}

.confirm-btn {
  width: 20rem;
  height: 3.3rem;
  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--white);
  background-color: var(--interaction-yellow);
  border: 1px solid var(--interaction-yellow);
  border-radius: var(--main-border-radius);
}

.modal-title {
  font-size: 2.7rem;
  font-size: 2rem;
  text-align: center;
}

.total-size-modal {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 55rem;
  width: 85%;
  height: 23rem;
  background-color: white;
  z-index: 1;
  border-radius: var(--main-border-radius);
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  z-index: 2;
}


.modal-container {
  width: 100%;
  height: 100%;
  background-color: #d9d9d9db;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 2;
}

input[type="number"]::-webkit-inner-spin-button {
  display: none;
}

@media screen and (max-width: 700px) {

  .modal-title {
    font-size: 1.2rem;
    width: 70%;
  }

  .confirm-btn {
    width: 80%;
    /* display: inline-block; */
    padding: 1.375rem 2.125rem 1.375rem 2.125rem;
    border-radius: 0.75rem;
    font: 700 1.25rem/0 "Roboto", sans-serif;
  }
  .total-size-input {
  border: 2px solid var(--dark-gray);
  width: 70%;
  height: 2.4rem;
  padding: 1rem;
  text-align: center;
  font-size: 1.2rem;
  }


}
</style>